{
    "welcome-to": "Willkommen bei",
    "copyright": "Urheberrecht",
    "trademarks": "Alle Marken oder eingetragenen Marken sind Eigentum ihrer jeweiligen Inhaber.",

    "menu-profile": "Profil",
    "menu-logout": "Abmelden",
    "menu-home": "Startseite",
    "menu-dashboard": "Dashboard",
    "menu-machines": "Maschinen",
    "menu-colaboration": "Zusammenarbeit",
    "menu-administration": "Verwaltung",
    "menu-machine": "Maschine",
    "menu-list": "Liste",
    "menu-service-data": "Servicedaten",
    "menu-trash": "Papierkorb",

    "machine-info": "Maschineninfo",
    "medium": "Medium",
    "machine-activity": "Maschinenaktivität",
    "machine-part-info": "Maschinenteilinformation",
    "name": "Name",
    "version": "Version",
    "owner": "Eigentümer",
    "state": "Zustand",
    "actions": "Aktionen",
    "kind": "Art",
    "description": "Beschreibung",
    "size": "Größe",
    "last-write": "Letzte Änderung",
    "ver": "Ver.",
    "restore": "Wiederherstellen",
    "when": "Wann",
    "type": "Typ",
    "level": "Ebene",
    "text": "Text",
    "tags": "Tags",
    "part-type": "Teiltyp",
    "firmware-version": "Firmware-Version",
    "model": "Modell",
    "created": "Erstellt",
    "modified": "Geändert",
    "status": "Status",
    "loading": "Laden",
    "fv": "F.w.",
    "remove": "Entfernen",
    "user": "Benutzer",
    "fenix-version": "Fenix-Version",
    "service-data-remove-question": "Möchten Sie diese Servicedaten wirklich löschen?",
    "save-as-duplicate": "Als Duplikat speichern",
    "upload-file": "Datei hochladen",
    "restore-machine-data-from-backup": "Maschinendaten aus dem Backup wiederherstellen",
    "you-want-to-change-owner": "Möchten Sie den Eigentümer ändern?",
    "choose-file": "Datei auswählen",
    "detail": "Detail",
    "yes": "Ja",
    "no": "Nein",
    "machine-detail-remove-question": "Sind Sie sicher, dass Sie diese Maschine löschen möchten?",
    "status-auto-update": "Status automatische Aktualisierung",
    "download": "Herunterladen",
    "copy": "Kopieren",
    "move": "Verschieben",
    "change-owner": "Eigentümer ändern",
    "new-machine-name": "Neuer Maschinenname",
    "submit": "Absenden",
    "set-as-current": "Als aktuell festlegen",
    "checkout": "Kasse",
    "base-data": "Basisdaten",
    "part-structure-type": "Teilestrukturtyp",
    "owner-id": "Eigentümer-ID",
    "parent-id": "Eltern-ID",
    "part-class-type": "Teilklassentyp",
    "errors": "Fehler",
    "generic-device": "Generisches Gerät",
    "device-model": "Gerätemodell",
    "address": "Adresse",
    "camera-info": "Kamerainformationen",
    "sensor-model": "Sensormodell",
    "slides-in-view": "Ansicht Folien",
    "slider-info": "Schieberinformationen",
    "channels": "Kanäle",
    "shot-stats-from": "Schussstatistiken von",
    "shot-stats-to": "Schussstatistiken bis",
    "shot-stats-counter": "Schussstatistikzähler",
    "shot-stats": "Schussstatistiken",
    "slider": "Schieber",
    "valve": "Ventil",
    "number-shots": "Anzahl der Schüsse",
    "custom": "Benutzerdefiniert",
    "move-machine": "Maschine verschieben",
    "machine-is-not-selected": "Maschine ist nicht ausgewählt.",
    "machine-successfully-deleted": "Maschine erfolgreich gelöscht.",
    "failed-to-delete-machine": "Fehler beim Löschen der Maschine.",
    "failed-to-backup-machine": "Fehler beim Sichern der Maschine.",
    "owner-successfully-changed": "Eigentümer erfolgreich geändert.",
    "failed-to-change-owner": "Fehler beim Ändern des Eigentümers.",
    "machine-successfully-copied": "Maschine erfolgreich kopiert.",
    "failed-to-copy-machine": "Fehler beim Kopieren der Maschine.",
    "machine-successfully-moved": "Maschine erfolgreich verschoben.",
    "failed-to-move-machine": "Fehler beim Verschieben der Maschine.",
    "machine-set-as-current": "Maschine als aktuell festgelegt.",
    "install-app-question": "Möchten Sie die 3U Vision Cloud App installieren?",
    "install": "Installieren",
    "cancel": "Abbrechen",
    "install-application": "Anwendung installieren",
    "step": "Schritt",
    "tap-share-icon": "Tippen Sie auf das Teilen-Symbol.",
    "scroll-down-and-tap": "Im Teilen-Menü nach unten scrollen und tippen",
    "add-to-home-screen": "Zum Startbildschirm hinzufügen",
    "you-will-be-propted": "Sie werden aufgefordert, der App einen Namen zu geben. Sie können den Standardnamen beibehalten oder ihn nach Belieben ändern. Dann tippen Sie auf",
    "add": "Hinzufügen",
    "in-top-right-corner": "oben rechts",
    "do-not-show-again": "Nicht mehr anzeigen",
    "you-are-offline": "Sie sind offline.",
    "app-can-not-work-offline": "Die App kann offline nicht funktionieren.",
    "please-check-your-internet-connection": "Bitte überprüfen Sie Ihre Internetverbindung.",
    "unexpected-server-version": "Unerwartete Serverversion.",
    "current-is": "Aktuell ist",
    "and-expected": "und erwartet",
    "application-version-is": "Anwendungsversion ist",
    "new-version-available": "Neue Version verfügbar",
    "do-you-want-to-install": "Möchten Sie installieren?",
    "delete-confirmation": "Löschbestätigung",
    "machine-medium-remove-question": "Sind Sie sicher, dass Sie das Medium löschen möchten?",
    "machine-medium-checkout-error": "Fehler beim Auschecken des Maschinenmediums.",
    "invalid-data": "Ungültige Daten.",
    "failed-to-load-messages": "Fehler beim Laden der Nachrichten.",
    "failed-to-save-board": "Fehler beim Speichern des Boards.",
    "failed-to-delete-board": "Fehler beim Löschen des Boards.",
    "machine-structure-caption": "Struktur",
    "machine-structure-value-caption": "Wert",
    "machine-structure-not-available" : "Maschinenstruktur ist nicht verfügbar",
    "machines-upload-file-upload-in-progress": "Datei-Upload läuft.",
    "upload-success": "Hochladen erfolgreich."
  }
